import * as Sentry from "@sentry/react";
import firebase from "firebase/app";
import "firebase/firestore";

import { useEffect } from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router-dom";

import watchPermissionDenied, { reportToSentry } from "astrid-firestore/src/utils/watchPermissionDenied";
import { isDevelopment, isProduction, isStage } from "astrid-helpers/src/env";
import { name, version } from "astrid-web/package.json";

Sentry.init({
	dsn: "https://af221391a79e4ebf848eeeb24ed2d047@sentry.io/1724157",
	release: `${name}@${version}`,
	environment: (isProduction && ((isStage && "staging") || "production")) || "development",
	beforeSend(event, hint) {
		// ignore events
		if (
			// ignore broken master tool player loop to avoid exhausting Sentry events...
			event.exception?.values?.[0]?.value === "Cannot read property '_id' of undefined" ||
			// ignore a Firestore refusal reported again, after watchPermissionDenied reported it with its paths
			(hint?.originalException?.sentryEventId && !event.tags?.firestoreOperation) ||
			// ignore development errors
			isDevelopment
		) {
			return null;
		}

		return event;
	},
	integrations: [
		new Sentry.Feedback({
			autoInject: false,
		}),
		new Sentry.BrowserTracing({
			routingInstrumentation: Sentry.reactRouterV6Instrumentation(
				useEffect,
				useLocation,
				useNavigationType,
				createRoutesFromChildren,
				matchRoutes,
			),
		}),
		new Sentry.BrowserProfilingIntegration(),
	],
	tracesSampleRate: 1.0,
	tracePropagationTargets: [/astrid.fm/],
	profilesSampleRate: 1.0,
});

watchPermissionDenied(firebase.firestore, reportToSentry(Sentry));

export default Sentry;
